export default __webpack_public_path__ + "static/media/bannerEsolEducation.894ad503.png";